import React from 'react';
import _ from 'lodash';

import queryString from 'query-string';
import {withRouter} from "react-router";
import {connect} from 'react-redux';
import {
  TOKEN_KEY,
  setInStorage,
  NEW_ORIGIN_KEY,
  getFromStorage,
  CUSTOMER_ID_KEY,
  HIDE_CUSTOMER_HEADER_KEY,
  STORAGE_TYPE,
  removeFromStorage,
} from "../../../utils/storage";
import {SharedSettingsResource} from "../../../utils/api";

import CircularProgress from '@material-ui/core/CircularProgress';

import {login, logout} from "./actions";
import ErrorModal from '../../../components/ErrorModal';
import {PERMISSION_ERROR_MODAL_MESSAGE} from "../../../utils/constants";
import {AuthResource} from "../../../utils/api";
import {saveCustomerIdByUserName} from "../../CustomerDashboard/utils";
import {brokerLogout, customerLogout} from "./utils";
import { setSharedSettings } from '../../../components/SharedSettingsProvider/actions';
import {getAuthSelector, getSharedSettingsSelector} from "../../../utils/redaxSelectors";
import {toBoolean} from "../../../utils/utils";

const mapStateToProps = (state) => ({
  auth: getAuthSelector(state),
  sharedSettings: getSharedSettingsSelector(state),
});

class AuthenticationProvider extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: undefined
    };
    this.handleBrokerAuthFlow = this.handleBrokerAuthFlow.bind(this);
    this.handleErrorModalClose = this.handleErrorModalClose.bind(this);
  }

  componentDidMount() {
    (async () => {
      await this.handleBrokerAuthFlow();
      this.props.handleInvestmentDynamicPath()
    })()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.auth.error && this.props.auth.user && this.props.auth.user.is_broker){
      brokerLogout();
    }
  }

  async retriveSharedSettings() {
    try {
      const sharedSettings = await SharedSettingsResource.at('data/').get();
      this.props.dispatch(setSharedSettings(sharedSettings || {}));
    } catch {
      this.props.dispatch(setSharedSettings({}));
    }
  }

  async handleBrokerAuthFlow() {
    const {broker_id, customer_id, authorizationCode, clientId, code, code_verifier, origin, ...restQuery} = queryString.parse(this.props.location.search);

    const customerAuthCode = authorizationCode;
    const customerGUID = clientId;
    const codeVerifier = code_verifier || getFromStorage('code_verifier');
    let backUrl;

    if(origin){
      setInStorage(NEW_ORIGIN_KEY, origin);
      // in case it's redirect from CRM - logout current user for re-login
      if (this.props.auth.user && this.props.auth.user.is_broker) {
        return brokerLogout();
      }
    }

    if ((customerAuthCode && customerGUID) || ((customer_id || codeVerifier) && code)) {
      try {
        this.setState({loading: true});

        let requestBody = {};

        if(customerAuthCode){
          requestBody.code = customerAuthCode;
          requestBody.customer_id = customerGUID;
          requestBody.customer_auth_flow = true;
        } else {
          requestBody = {code};

          if (customer_id) {
            requestBody.customer_id = customer_id
          }

          if(codeVerifier){
            requestBody.code_verifier = codeVerifier.code_verifier;
            requestBody.redirect_uri = codeVerifier.redirectUri;
            backUrl = codeVerifier.backUrl;
            removeFromStorage('code_verifier')
          }
          if(broker_id){
            requestBody.broker_id = broker_id;
          }
        }

        const response = await AuthResource.at('token/').post(requestBody);
        const user = {...response.user};

        if (user.is_broker) {
          user.broker_id = user.broker.broker_id;
        } else if (customer_id) {
          user.customer_id = customer_id;
          user.broker_id = customer_id;
          saveCustomerIdByUserName(response.user.username);
          // we need to show header in case auth from our web app
          setInStorage(HIDE_CUSTOMER_HEADER_KEY, false, STORAGE_TYPE.SESSION)
        } else if (customerAuthCode) {
          // set customer_id in storage
          saveCustomerIdByUserName(response.user.username);
          // get customer id from storage and set it to user
          let customer_id = getFromStorage(CUSTOMER_ID_KEY);
          user.customer_id = customer_id;
          user.broker_id = customer_id;
          setInStorage(HIDE_CUSTOMER_HEADER_KEY, toBoolean(_.get(restQuery, 'hideHeader', true)), STORAGE_TYPE.SESSION)
        }

        setInStorage(TOKEN_KEY, response.token);

        this.props.dispatch(login(user));

        this.setState({loading: false, error: undefined});
        await this.retriveSharedSettings();
        if(backUrl){
          this.props.history.replace(backUrl)
        } else {
          let url = window.location.origin + window.location.pathname;
          if(!_.isEmpty(restQuery)){
            url += ('?' + queryString.stringify(restQuery))
          }
          window.history.replaceState(null, document.title, url);
        }
      }catch (error) {
        this.props.dispatch(logout());
        this.setState({loading: false, error});
      }
    }

  };

  handleErrorModalClose() {
    if (this.props.auth.user && this.props.auth.user.is_customer) {
      return customerLogout();
    }

    if (this.props.auth.user && this.props.auth.user.is_broker) {
      return brokerLogout();
    }
  };

  render() {

    if (this.state.loading){
      return (
        <div style={{
          display: 'flex',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <CircularProgress/>
        </div>
      )
    } else if((this.state.error || this.props.auth.error)){
      return (
        <ErrorModal message={PERMISSION_ERROR_MODAL_MESSAGE} handleClose={this.handleErrorModalClose.bind(this)}/>
      )
    }

    return this.props.children;
  }
}

export default connect(mapStateToProps)(withRouter(AuthenticationProvider));